import React from 'react';

import { useStackNavigationContext } from 'core/navigation';
import { ScreenContainer } from 'ui/component';
import { useAnalytics } from '../../analytics';
import { HomeFlippingCard, HomeFlippingCardType } from '../../component';
import { ROOT_ROUTE } from '../../navigation';
import classNames from './EABD2HomeScreen.module.scss';

export const HomeScreen = React.memo(() => {
  const { onDiscoverMoreClick } = useAnalytics();
  const { push } = useStackNavigationContext();
  const [flippingCards] = React.useState<HomeFlippingCardType[]>(() => ['network', 'customer', 'business']);

  const OnDiscoverMoreButtonPressCallback = React.useCallback(
    (type: HomeFlippingCardType) => {
      switch (type) {
        case 'network':
          onDiscoverMoreClick('Ensure superior network performance');
          push({ screen: ROOT_ROUTE.CASE1 });
          break;
        case 'customer':
          onDiscoverMoreClick('Create future-proof customer experience');
          push({ screen: ROOT_ROUTE.CASE2 });
          break;
        case 'business':
          onDiscoverMoreClick('Turn operations into an efficient business enabler');
          push({ screen: ROOT_ROUTE.CASE3 });
          break;
      }
    },
    [onDiscoverMoreClick, push]
  );

  const RenderFlippingCardCallback = React.useCallback(
    (type: HomeFlippingCardType, index: number) => {
      return (
        <React.Fragment key={`${type}-${index}`}>
          <HomeFlippingCard type={type} onDiscoverMoreButtonPress={OnDiscoverMoreButtonPressCallback} />
          {index < flippingCards.length - 1 && <div className={classNames.separator} />}
        </React.Fragment>
      );
    },
    [flippingCards, OnDiscoverMoreButtonPressCallback]
  );

  return (
    <ScreenContainer>
      <div className={classNames.content}>{flippingCards.map(RenderFlippingCardCallback)}</div>
    </ScreenContainer>
  );
});
